import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {SecureFuelService} from '../../service/securefuel/secureFuelService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';


/* global customElements */
class SFUnitGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
						
		this.admin = false;	
		
		var unitGrid = this;
		setTimeout(function(){
			unitGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var unitGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',
			children: [				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterCustomer',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Customer Id',
					listeners: {
						input: {
							fn: function() {
								//actionRefresh();
							},
							buffer: 2000
					    }
					}
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filterUnit',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Unit Id',
					listeners: {
						input: {
							fn: function() {
								//actionRefresh();
							},
							buffer: 2000
					    }
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:search', ' Search')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'import',
							'class': 'spacer-toolbar-item',	
							style: 'margin-top: 35px',
							permissions: ['ADMIN_SECURE_FUEL_UNIT:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', ' Import')						
							],
							listeners: {
								click: function() {
									actionImport();
								}
							}							
						}
					]
				}
			]
		});		
		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_SECURE_FUEL_UNIT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_SECURE_FUEL_UNIT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',
							permissions: ['ADMIN_SECURE_FUEL_UNIT:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')						
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems);
								}
							}							
						}
					]
				}				
			]
		});
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},				
				{						
					path: 'carrierId',
					header: 'Customer Id',
					width: '7em'
				},
				{						
					path: 'unitId',
					header: 'Unit Id',
					width: '7em'
				},	
				{						
					path: 'groupId',
					header: 'Group Id',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'tank1Capacity',
					header: 'Tank 1 Capacity',					
					width: '7em'
				},
				{						
					path: 'tank2Capacity',					
					header: 'Tank 2 Capacity',					
					width: '7em'
				},
				{						
					path: 'lastEventChecked',
					header: 'Last Event Checked',
					width: '14em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.lastEventChecked) {
							var date = TimeUtil.parseDate(rowData.item.lastEventChecked);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						}
					}
				},
				{						
					path: 'maxEventTime',
					header: 'Max Event Checked',
					width: '14em',					
					renderer: function(root, column, rowData) {
						if (rowData.item.maxEventTime) {
							var date = TimeUtil.parseDate(rowData.item.maxEventTime);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						}
					}
				}		
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
		
		
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					if (grid.selectedItems.length === 1) {						
						ElementUtil.query(toolbar, 'edit').disabled = false;						
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {
						
						ElementUtil.query(toolbar, 'edit').disabled = true;						
						ElementUtil.query(toolbar, 'delete').disabled = false;
					}					
				} else {											
					ElementUtil.query(toolbar, 'edit').disabled = true;						
					ElementUtil.query(toolbar, 'delete').disabled = true;
				}					
			});
		};		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
						
						grid.currentFilter = {
							offset: pageRange.offset,
							limit: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'recordDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',	
							unitIdMatch: ElementUtil.query(toolbarFilter, 'filterUnit').value
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
														
							grid.items = records.units;
							
							setTimeout(function(){
								gridSelectionChange();
							}, 50);
							
							pagingToolbar.totalRecords = records.total;
							pagingToolbar.updatePager();

						};
						
						var customerId = ElementUtil.query(toolbarFilter, 'filterCustomer').value;
						if (customerId) {															
							SecureFuelService.getUnitService().getUnitsForCustomer(grid.currentFilter, customerId).then(function(records) {								
								successHandler(records);
							}, function(){
								loadMask.remove();
							});
						} else {
							loadMask.remove();							
							ElementUtil.query(toolbarFilter, 'filterCustomer').validate();								
							window.DL.MessageUtil.showToastError('A Customer Id must be selected');							
						}
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				actionExport();
			}
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		unitGrid.append(flexLayout);		
			
		var actionRefresh = function () {
			pagingToolbar.loadPage(1);				
		};
		attachWorkspaceFilterState(unitGrid, toolbarFilter, ['filterCustomer','filterUnit'], actionRefresh);
		
		var actionAddEdit = function (record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Unit' : 'Add Unit',
				icon: 'vaadin:edit',				
				width: 700,
				height: 460,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var customerId = ElementUtil.query(toolbarFilter, 'filterCustomer').value;
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-text-field',
											itemid: 'carrierId',
											label: 'Customer Id',
											name: 'carrierId',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,	
											value: customerId,
											postinit: function (combo) {												
											}
										},
										{
											tag: 'vaadin-text-field',
											itemid: 'unitId',
											label: 'Unit Id',
											name: 'unitId',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,												
											postinit: function (combo) {												
											}
										},
										{
											tag: 'vaadin-number-field',												
											name: 'groupId',
											label: 'groupId',
											required: true,
											min: 0,
											max: 999999999
										},
										{
											tag: 'vaadin-number-field',												
											name: 'tank1Capacity',
											label: 'Tank 1 Capacity',
											required: true,
											min: 0,
											max: 999
										},									
										{	
											tag: 'vaadin-number-field',												
											name: 'tank2Capacity',
											label: 'Tank 2 Capacity',
											required: true,
											min: 0,
											max: 999
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {			
																																																					
															formPanel.submitForm({																
																preSubmit: function(data) {																																																
																	return data;
																},
																actualCall: function(data) {																				
																	return SecureFuelService.getUnitService().saveUnit(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Unit', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						
						if (record) {								
							//wait for render;shift to end of event loop
							setTimeout(function() {
								formPanel.load(record);																							
									
							});
						}
					}
				}
			});				
		};
		
		var actionImport = function () {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Import Units',
				icon: 'vaadin:upload',
				width: 450,
				height: 220,
				listeners: {
					ready: function() {
						uploadWin.show();

						var uploadHandler = function() {

							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A unit csv import file is required.');
							} else {
								uploadField.uploadFiles();
							}

						};

						var uploadFormPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-upload',
									itemid: 'uploadField',
									'no-auto':  true,
									'max-files': 1,
									required: true,
									target: '/api/resource/secure-fuel-units/import',
									headers: ImportUtil.getUploadHeader(),
									listeners: {
										'upload-request': function(event) {
										},
										'upload-success': function(event) {
											var responseData = JSON.parse(event.detail.xhr.responseText);
											if (responseData.uploadFile) {
												//error
												window.DL.MessageUtil.showOkMessage(
													responseData.uploadFile + '<br>' +
													responseData.uploadFileType ? responseData.uploadFileType : ''
												);
											} else {
												var customerId = ElementUtil.query(toolbarFilter, 'filterCustomer').value;
												if (customerId) {
													actionRefresh();
												}
												uploadWin.close();
											}
										}
									}
								},
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:upload', ' Upload')
													],
													listeners: {
														click: function() {
															if (uploadFormPanel.isValid()) {
																uploadHandler();
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															uploadWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});
						uploadWin.addToContentElement(uploadFormPanel);

					}
				}


			});			
		};
		
		var actionExport = function () {			
			var customerId = ElementUtil.query(toolbarFilter, 'filterCustomer').value;
			var unitId = ElementUtil.query(toolbarFilter, 'filterUnit').value;
			if (customerId) {
				var options = null;
				if (unitId) {
					 options= {
						unitIdMatch: unitId
					};
				}
				SecureFuelService.getUnitService().downloadUnits(customerId, options);
			} else {
				ElementUtil.query(toolbarFilter, 'filterCustomer').validate();
				window.DL.MessageUtil.showToastError('A Customer Id must be selected first');
			}
			
		};
		
		var actionDelete = function (records) {
			
			var customerId = ElementUtil.query(toolbarFilter, 'filterCustomer').value;
			if (customerId) {
				var multipleIds = {
					ids: []
				};
				records.forEach(function (record) {
					multipleIds.ids.push(
							record.unitId
							);
				});

				window.DL.MessageUtil.showConfirm({
					title: 'Confirm Delete',
					message: 'Are you sure you want to delete selected records?',
					buttons: [
						{
							text: 'Yes',
							handler: function () {
								var loadMask = grid.showLoading('Removing...');

								SecureFuelService.getUnitService().deleteUnits(customerId, multipleIds)
										.then(function () {
											loadMask.remove();
											window.DL.MessageUtil.showToast('Success', 'Removed: ' + multipleIds.ids.length, {
												theme: 'success'
											});
											actionRefresh();
										});
							}
						},
						{
							text: 'No'
						}
					]
				});
			} else {
				ElementUtil.query(toolbarFilter, 'filterCustomer').validate();
				window.DL.MessageUtil.showToastError('A Customer Id must be selected first');
			}			
		};
		
	}
	
}
customElements.define('dl-sf-unit-grid', SFUnitGrid);
